import { Dispatch } from 'redux';
import { ISite, ISiteSetupDTO, Site, SiteSetupDTO } from 'shared/api/api';
import { AsyncOperationBuilder2 } from 'shared/helpers/redux-helpers';
import { localized } from 'shared/state/i18n/i18n';
import { StoreContainer } from 'shared/state/store-container';
import { showErrorSnackbar, showSuccessSnackbar } from '../snackbar/snackbar-slice';
import * as Action from './actions';

export const GetSite = (id: string) => {
	return AsyncOperationBuilder2(Action.getSiteAsync, cl => cl.sites_Get(id), id);
};

export const GetByProfile = (profileId: string) => {
	return AsyncOperationBuilder2(Action.getSiteAsync, cl => cl.sites_GetByProfile(profileId), profileId);
};

export const GetByProfileAsync = (profileId: string) => {
	return AsyncOperationBuilder2(Action.getSiteAsync, client => client.sites_GetByProfile(profileId), profileId);
};

export const GetAllSites = () => {
	return AsyncOperationBuilder2(Action.getAllSitesAsync, client => client.sites_GetAllSites(), {});
};

export const GetArchivedSites = () => {
	return AsyncOperationBuilder2(Action.getArchivedSites, client => client.mongoArchive_GetArchivedSties(), {});
};

export const MigrateDownstream = (siteId: string, entities: string[], showAlert: (exceptionMessage: string) => void) => {
	return AsyncOperationBuilder2(Action.migrationDownstreamAsync, client => client.adminFeatures_MigrateDownstream(siteId, entities), { siteId, entities },
		undefined, undefined, undefined, undefined,
		(errorCode: number, message: string) => {
			showAlert(localized(message));
		});
}

export const MigrateToArchive = (siteId: string, showAlert: (exceptionMessage: string) => void) => {
	return AsyncOperationBuilder2(Action.migrationToArchiveAsync, client => client.mongoArchive_MigrateToArchive(siteId), siteId,
		undefined, undefined, undefined, undefined,
		(errorCode: number, message: string) => {
			showAlert(localized(message));
		});
}

export const MigrateFromArchive = (siteId: string, showAlert: (exceptionMessage: string) => void) => {
	return AsyncOperationBuilder2(Action.migrationFromArchiveAsync, client => client.mongoArchive_MigrateFromArchive(siteId), siteId,
		undefined, undefined, undefined, undefined,
		(errorCode: number, message: string) => {
			showAlert(localized(message));
		});
}

export const SaveSiteAsync = (site: ISite, onSucess?: () => void, errorAlert?: () => void) => {
	let siteToSave = Site.fromJS({});
	siteToSave.init(site);
	return AsyncOperationBuilder2(
		Action.saveSiteAsync,
		client => client.sites_Upsert(siteToSave),
		siteToSave,
		undefined,
		undefined,
		() => {
			if (onSucess) {
				onSucess();
			}
		},
		0,
		(errorCode: number, message: string) => {
			if (errorAlert) {
				errorAlert();
			}
		},
	);
};

export const CreateSiteAndRegisterAsync = (siteSetup: ISiteSetupDTO, isEditing = false) => {
	let newSite = SiteSetupDTO.fromJS({});
	newSite.init(siteSetup);

	return AsyncOperationBuilder2(
		Action.createSiteAsync,
		client => client.sites_CreateAndRegisterSite(newSite),
		newSite,
		undefined,
		undefined,
		(_result, dispatch: Dispatch<any>) => {
			dispatch(showSuccessSnackbar(localized(isEditing ? 'SiteUpdatedSuccessfully' : 'SiteCreatedSuccessfully')));
		},
		0,
		(_errorCode: number, _message: string) => {
			StoreContainer.dispatchAction(
				showErrorSnackbar({
					msg: localized(isEditing ? 'SiteUpdateFailed' : 'SiteCreateFailed'),
					duration: 5000,
				}),
			);
		},
	);
};
